// extracted by mini-css-extract-plugin
export default {"root":"styles_root__fcsPS","delete-button":"styles_delete-button__UjEBh","icon":"styles_icon__xm+bj"};